import { useTranslation } from 'react-i18next'
import { useAsyncJobStore } from 'src/stores/async-jobs'
import { cn } from 'src/utils/style'

interface JobProgressBarProps {
  taskType: string
  entityId: string
  className?: string
}

export const JobProgressBar = ({ taskType, entityId, className }: JobProgressBarProps) => {
  const { t } = useTranslation()
  const job = useAsyncJobStore((s) =>
    s.active.find((j) => j.taskType === taskType && j.entityId === entityId),
  )

  if (!job) return null

  const percent =
    job.progressTotal > 0 ? Math.round((job.progressCurrent / job.progressTotal) * 100) : 0

  return (
    <div
      className={cn('rounded-lg border border-border bg-surface p-4', className)}
      data-testid="job-progress-bar"
    >
      <div className="mb-2 flex items-center justify-between text-sm">
        <span className="font-medium text-primary-700">
          {job.phase || t('statementReview.processing')}
        </span>
        {job.progressTotal > 0 && (
          <span className="text-text-placeholder">
            {t('statementReview.progressRows', {
              current: job.progressCurrent,
              total: job.progressTotal,
            })}
          </span>
        )}
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-primary-100">
        <div
          className="h-full rounded-full bg-primary-500 transition-all duration-300"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  )
}
